// libs
import React from 'react';
import PropTypes from 'prop-types';
// shared components
import { LocaleString } from '@biw/intl';
import { ShoppingBagIcon } from 'components/library';
import CatalogButton from './catalog-button';
import ShopItem from './shop-item';
// utils
import { openCatalog } from './shop-utils';
// scss
import './shop.scss';

export default class Shop extends React.Component {
    static propTypes = {
        carouselSize: PropTypes.string,
        fetchCatalogUrl: PropTypes.func.isRequired,
        plainTextLinkText: PropTypes.string,
        hideButton: PropTypes.bool,
        showHeader: PropTypes.bool,
        showTextLink: PropTypes.bool,
        userIsLaunchAs: PropTypes.bool,
        cssClass: PropTypes.string
    }

    static defaultProps = {
        hideButton: false,
        showHeader: false,
        userIsLaunchAs: false,
        fetchCatalogUrl: () => {},
        cssClass: ''
    }

    openCatalog = ( event ) => {
        openCatalog( event, this.props.fetchCatalogUrl );
    }

    render () {

        const {
            hideButton,
            showHeader,
            showTextLink,
            carouselSize,
            plainTextLinkText,
            userIsLaunchAs,
            cssClass
        } = this.props;

        return(
            <div className="shop-component">

                { showHeader &&
                    <div>
                        <LocaleString TextComponent="h3" className="shop-header" code="shop.headline" />
                        <LocaleString TextComponent="p" className="shop-subheader"  code="shop.subhead" />
                    </div>
                }

                { showTextLink && plainTextLinkText &&
                    <a href="#" onClick={ this.openCatalog } className="catalog-link branding-secondary-text">{ plainTextLinkText }</a>
                }

                <ul className={ 'shop-list' + ( carouselSize === 'large' ? ' shop-list-large' : ' shop-list-small' ) }>
                    <ShopItem data-sel="welcome-shop-shopper" disabled={ userIsLaunchAs } className="catalog-shop-item" onClick={ this.openCatalog }>
                        <img className="catalog-shop-item-img shop-item-img" src={ require( '../../../assets/img/catalog-shop-600.jpg' ) } alt="happy woman on phone"/>
                    </ShopItem>
                    <ShopItem data-sel="welcome-shop-travel" disabled={ userIsLaunchAs } className="travel-shop-item" onClick={ this.openCatalog }>
                        <img className="travel-shop-item-img shop-item-img" src={ require( '../../../assets/img/catalog-travel-600.jpg' ) } alt="airplane launching"/>
                    </ShopItem>
                    <ShopItem data-sel="welcome-shop-cart" title="Open Catalog" disabled={ userIsLaunchAs } className={ `cart-shop-item ${cssClass}` } onClick={ this.openCatalog }>
                        <ShoppingBagIcon / ><span className="hidden"><LocaleString code="common.buttons.openCatalog" /></span>
                    </ShopItem>
                </ul>
                { !hideButton &&
                    <CatalogButton
                        disabled={ userIsLaunchAs }
                        buttonLocaleCode="common.buttons.openCatalog"
                        brandingInverted
                    />

                }
            </div>
        );
    }
}
